module.exports = __webpack_public_path__ + "static/media/screen-4.fa491589.png";